import { BrandEnum } from "../_common/enum/brand.enum";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";
import { getFormAccessToken } from "../_helpers/formAccessToken.helper";

const API_NAME = "quoteComparison";

export const quoteComparisonService = {
    getQuotes,
    getMortgageQuotes,
};

function getQuotes(formId: number, brand: BrandEnum) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const accessToken = getFormAccessToken(formId);
    let url = `${API_URL}/${API_NAME}/GetQuotes/?formId=${formId}&brand=${brand}`;
    if (accessToken) {
        url += `&token=${encodeURIComponent(accessToken)}`;
    }
    return fetch(url, requestOptions).then(handleResponse);
}

function getMortgageQuotes(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const payload = { ...query, token: getFormAccessToken(query?.formId) };
    return fetch(`${API_URL}/${API_NAME}/getMortgageQuotes?${getQuery(payload)}`, requestOptions).then(handleResponse);
}

